
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
export default {
    tooltip: {
        trigger: 'item',
        formatter: "{a} <br/>{b}: {c} ({d}%)"
    },
    legend: {
        orient: 'vertical',
        x: 'left',
        data:[getLabel(387994,"直接访问"),getLabel(387995,"邮件营销"),getLabel(387996,"联盟广告")]
    },
    series: [
        {
            name:getLabel(387997,"访问来源"),
            type:'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
                normal: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    show: true,
                    textStyle: {
                        fontSize: '30',
                        fontWeight: 'bold'
                    }
                }
            },
            labelLine: {
                normal: {
                    show: false
                }
            },
            data:[
                {value:335, name:getLabel(387994,"直接访问")},
                {value:310, name:getLabel(387995,"邮件营销")},
                {value:234, name:getLabel(387996,"联盟广告")}
            ]
        }
    ]
};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/echart/examples/doughnut.js